module.exports = __webpack_public_path__ + "static/media/13.968e348e.jpg";